import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IndustryPickerComponent } from '../../industry-picker/industry-picker.component'

@Injectable({
  providedIn: 'root'
})
export class IndustryPickerService {

  public pickIndustry(successActionDispatcher: (industryIds: string[])=>void, initialData: string[]=[]){
    let dialogRef = this.dialog.open(IndustryPickerComponent, {
      height: 'calc(100vh - 4rem)',
      width: '48rem',
      panelClass: 'common-dialog-container',
      data: {
        industryIds: initialData,
        label: 'label.FillInExperienceIndustry'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined && result !== null){
        successActionDispatcher(result);
      }
    });
  }

  constructor(private dialog: MatDialog) { }
}
